import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Experiences from './pages/Experiences';
import Contact from './pages/Contact';
import Memberships from './pages/Memberships';
import Library from './pages/Library';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/experiences" element={<Experiences />} />
                  <Route path="/memberships" element={<Memberships />} />
                  <Route path="/library" element={<Library />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;